import { render } from "./AddDiskOffering.vue?vue&type=template&id=262c71ac&scoped=true"
import script from "./AddDiskOffering.vue?vue&type=script&lang=js"
export * from "./AddDiskOffering.vue?vue&type=script&lang=js"

import "./AddDiskOffering.vue?vue&type=style&index=0&id=262c71ac&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262c71ac"]])

export default __exports__